import qs from 'qs'
import { loading, toast } from 'utils/toast'
import { sortObj } from 'utils/util'

export const brokerBase = (function () {
  const aesKey = 'D21Uq65MzDF28PaEx7zO0dSM2WuG03z0'
  const salt = '12344404K53N5571lz91673701u04321'
  return {
    AES: {
      encrypt: plaintText => window.encrypt.enc.AES.encrypt(plaintText, aesKey),
      decrypt: cipherText => window.encrypt.enc.AES.decrypt(cipherText, aesKey)
    },
    MD5: plaintText => window.encrypt.enc.MD5(plaintText, false, salt)
  }
})()
export const brokerMemberCrypto = (function () {
  return {
    // 经纪会员请求入参加密
    encryptReq: content => {
      const timestamp = Date.parse(new Date().toString())
      const aseContent = brokerBase.AES.encrypt(content)
      const bizContentSign = brokerBase.MD5(
        sortObj({
          dynamic_secret: false,
          random_number: timestamp,
          content: aseContent
        })
      )
      const bizContent = {
        dynamic_secret: false,
        random_number: timestamp,
        sign: bizContentSign,
        content: aseContent
      }
      const retSign = brokerBase.MD5(
        sortObj({ biz_content: bizContent, request_no: timestamp, timestamp })
      )
      const ret = {
        biz_content: bizContent,
        request_no: timestamp,
        sign: retSign,
        timestamp
      }
      return ret
    },
    // 经纪会员请求报文解密
    decryptReq: params => {
      return JSON.parse(brokerBase.AES.decrypt(params.biz_content.content))
    },
    // 经纪会员响应报文解密
    decryptRes: res => {
      return JSON.parse(brokerBase.AES.decrypt(res.biz_content))
    }
  }
})()

// 经纪会员请求报文加密拦截
const brokerEncryptReqInterceptor = [
  function (config) {
    if (!config.brokerEncrypt) {
      return config
    }
    if (process.env.VITE_ENV !== 'production') {
      console.log(`请求报文加密：${config.url}`, config.data)
    }

    // 会员接口加密
    config.data = brokerMemberCrypto.encryptReq(config.data)
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
]

// 经纪会员响应报文解密拦截
const brokerDecryptResInterceptor = [
  function (response) {
    if (!response.config.brokerEncrypt || response.data.err_code) {
      return response
    }
    response.data = brokerMemberCrypto.decryptRes(response.data)
    console.log('解密响应>>', response.data)
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
]

// 网电请求报文加密拦截
const wdEncryptReqInterceptor = [
  function (config) {
    if (!config.wdEncrypt) {
      return config
    }
    if (process.env.VITE_ENV !== 'production') {
      console.log(`请求报文加密：${config.url}`, config.data)
    }
    const params = window.encrypt.enc.AES.encrypt(
      config.data,
      'fe355d547d506890'
    )
    const sign = window.encrypt.enc.MD5(
      params,
      true,
      'fe355d547d506890689f2889464f323a63666543001011061'
    )
    config.data = {
      header: {
        serviceName: 'external-service-h5',
        token: sign, // 加密报文+盐
        userId: null
      },
      data: params
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
]

// 网电响应报文解密拦截
const wdDecryptResInterceptor = [
  function (response) {
    if (!response.config.wdEncrypt || response.data.err_code) {
      return response
    }
    if (response.data.status !== '0000') {
      toast({ message: response.data.message })
      return Promise.reject(new Error(response.data.message))
    }
    response.data = JSON.parse(
      window.encrypt.enc.AES.decrypt(response.data.data, 'fe355d547d506890')
    )
    console.log('解密响应>>', response.data)
    return response
  },
  function (error) {
    return Promise.reject(error)
  }
]

// 通用请求拦截器
const commonReqInterceptor = [
  config => {
    if (config.loading !== false) {
      loading.show()
    }
    return config
  },
  error => {
    console.log('request-error', qs.parse(error))
    loading.hide()
    return Promise.reject(error)
  }
]

// 通用响应拦截器
const commonResInterceptor = [
  response => {
    if (response.config.loading !== false) {
      loading.hide()
    }
    return response
  },
  error => {
    loading.hide()
    const errMsg = {}
    if (qs.parse(error).response) {
      switch (qs.parse(error).response.status) {
        case 400:
          errMsg.message = '请求错误(400)'
          break
        case 401:
          errMsg.message = '未授权，请重新登录(401)'
          break
        case 403:
          errMsg.message = '拒绝访问(403)'
          break
        case 404:
          errMsg.message = '请求出错(404)'
          break
        case 408:
          errMsg.message = '请求超时(408)'
          break
        case 500:
          errMsg.message = '服务器错误(500)'
          break
        case 501:
          errMsg.message = '服务未实现(501)'
          break
        case 502:
          errMsg.message = '网络错误(502)'
          break
        case 503:
          errMsg.message = '服务不可用(503)'
          break
        case 504:
          errMsg.message = '网络超时(504)'
          break
        case 505:
          errMsg.message = 'HTTP版本不受支持(505)'
          break
        default:
          errMsg.message = `连接出错(${qs.parse(error).response.status})!`
      }
      errMsg.status = qs.parse(error).response.status
      errMsg.url = qs.parse(error).response.config.url
    } else if (/^timeout/.test(error.message)) {
      errMsg.message = '请求超时'
    }
    toast({ message: errMsg.message })
    console.log('response-error', error, errMsg)
    return Promise.reject(errMsg)
  }
]

// 装载拦截器
const assembleIntercept = function (http) {
  const { request, response } = http.interceptors
  request.use.apply(request, commonReqInterceptor)
  request.use.apply(response, commonResInterceptor)
  request.use.apply(request, wdEncryptReqInterceptor)
  request.use.apply(response, wdDecryptResInterceptor)
  request.use.apply(request, brokerEncryptReqInterceptor)
  request.use.apply(response, brokerDecryptResInterceptor)
}

export { assembleIntercept }
